import LoginFeature from "@/features/Login";

export default function LoginPage() {
  return (
    <>
      <LoginFeature />
    </>
  );
}
